@use '@/sass/variables';

.groupChip {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  margin-right: 10px;
}

.hasPointerCursor {
  cursor: pointer;
}

.selectIsInvalid {
  border-color: variables.$red !important;
  color: variables.$near-black;
  box-shadow: 0 0 0 1px variables.$red !important;
}

.waringColor {
  color: variables.$gold;
}

.errorColor {
  color: variables.$dark-red;
}
